import { List, Map } from 'immutable';

import { ApiActions } from '../constants/ApiActions';
import { BrowseGenresKeys } from '../constants/BrowseGenres';
import { createReducer } from '../lib/ReducerUtils';

const INITIAL_STATE = Map({
  [BrowseGenresKeys.GENRE_CATEGORIES_HAVE_LOADED]: false,
  [BrowseGenresKeys.GENRE_CATEGORY_TOKENS]: List(),
  [BrowseGenresKeys.GENRE_CATEGORY_TOKENS_TO_GENRE_IDS]: Map(),
});

// BROWSEGENRES REDUCER
export default createReducer(INITIAL_STATE, {
  [ApiActions.FETCH_GENRE_CATEGORIES_SUCCESS]: fetchGenreCategoriesSuccess,
  [ApiActions.FETCH_GENRES_BY_CATEGORY_ID_SUCCESS]: fetchGenresByCategoryIdSuccess,
});

// CASE FUNCTIONS

function fetchGenreCategoriesSuccess(state, action) {
  return state.merge({
    [BrowseGenresKeys.GENRE_CATEGORIES_HAVE_LOADED]: true,
    [BrowseGenresKeys.GENRE_CATEGORY_TOKENS]: List(action.response.result.categories),
  });
}

function fetchGenresByCategoryIdSuccess(state, action) {
  const categoryToGenresMap = state.get(BrowseGenresKeys.GENRE_CATEGORY_TOKENS_TO_GENRE_IDS);
  const newCategoryToGenresMap = categoryToGenresMap.set(
    action.params.categoryToken,
    List(action.response.result.genres),
  );

  return state.set(BrowseGenresKeys.GENRE_CATEGORY_TOKENS_TO_GENRE_IDS, newCategoryToGenresMap);
}
